import Link from 'next/link';
import type { FC } from 'react';
import { ChevronLeftWithBorderIcon } from 'src/components/shared/elements/icons/ChevronLeftWithBorderIcon';
import { KaimonoWebRoutes } from 'src/config/routes';

type Props = {
  route: string;
  parentSlug: string;
};

export const PrevLink: FC<Props> = ({ route, parentSlug }) => {
  const categories = getCategoryRoute(route);

  if (!categories) {
    return null;
  }

  return (
    <Link href={categories.show(parentSlug)}>
      <a>
        <ChevronLeftWithBorderIcon />
      </a>
    </Link>
  );
};

const routeMap = new Map([
  ['middle', KaimonoWebRoutes.largeCategories],
  ['small', KaimonoWebRoutes.middleCategories],
  ['tiny', KaimonoWebRoutes.smallCategories]
]);

const getCategoryRoute = (route: string) => {
  for (const key of routeMap.keys()) {
    if (route.includes(key)) return routeMap.get(key);
  }
};
